import React, {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useState,
} from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

// TODO:// Change this to styled components
const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

interface ModalProps {
  titleText: string;
  bodyText: string;
  autoClose: boolean;
  updateParent: Dispatch<SetStateAction<boolean>>;
}

const BasicModal = ({
  titleText,
  bodyText,
  autoClose,
  updateParent,
}: ModalProps) => {
  const [open, setOpen] = useState(true);
  // const handleOpen = () => setOpen(true);
  const handleClose = useCallback(() => {
    updateParent(false);
    setOpen(false);
  }, [updateParent]);

  useEffect(() => {
    if (autoClose) {
      setTimeout(() => {
        handleClose();
      }, 5000);
    }
  }, [autoClose, handleClose]);

  return (
    <Box component="div">
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {titleText}
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {bodyText}
          </Typography>
        </Box>
      </Modal>
    </Box>
  );
};
export default BasicModal;
